import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Layout from "./components/site/Layout";
import Home from "./pages/Home";
import WeeklyConcierge from "./pages/WeeklyConcierge";
import MoveIn from "./pages/MoveIn";
import MoveOut from "./pages/MoveOut";
import RentalTurnovers from "./pages/RentalTurnovers";
import VacationRestocking from "./pages/VacationRestocking";
import RealtorServices from "./pages/RealtorServices";
import PropertyManagement from "./pages/PropertyManagement";
import HowItWorks from "./pages/HowItWorks";
import About from "./pages/About";
import Book from "./pages/Book";
import FAQ from "./pages/FAQ";
import Contact from "./pages/Contact";
import Careers from "./pages/Careers";
import Admin from "./pages/Admin";
import Legal from "./pages/Legal";
import NotFound from "./pages/NotFound";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route element={<Layout />}>
            <Route path="/" element={<Home />} />
            <Route path="/services/weekly-home-concierge" element={<WeeklyConcierge />} />
            <Route path="/services/move-in-concierge" element={<MoveIn />} />
            <Route path="/services/move-out-cleaning" element={<MoveOut />} />
            <Route path="/services/rental-turnovers" element={<RentalTurnovers />} />
            <Route path="/services/vacation-restocking" element={<VacationRestocking />} />
            <Route path="/services/realtor-services" element={<RealtorServices />} />
            <Route path="/services/property-management" element={<PropertyManagement />} />
            <Route path="/how-it-works" element={<HowItWorks />} />
            <Route path="/about" element={<About />} />
            <Route path="/book" element={<Book />} />
            <Route path="/faq" element={<FAQ />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/careers" element={<Careers />} />
            <Route path="/privacy" element={<Legal kind="privacy" />} />
            <Route path="/terms" element={<Legal kind="terms" />} />
            <Route path="*" element={<NotFound />} />
          </Route>
          <Route path="/admin" element={<Admin />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
